import type { LevelDef } from '../level.ts';

// Coast on the right, one pad by the water; helicopters land only on the pad.
export const lisbon: LevelDef = {
  id: 'lisbon', city: 'lisbon', country: 'portugal',
  blurb: 'coastal winds, sails, helicopters land only on the pad',
  baseline: 245, scoreMul: 1.4,
  capBase: 3, capDiv: 4, capMax: 6,
  spawnLead: [4, 10], minSpawnGap: 1.8, tempo: 1,
  mix: [['light', 0.26], ['medium', 0.28], ['heavy', 0.18], ['jet', 0.14], ['heli', 0.14]],
  layout: {
    runways: [
      { x1: -0.72, y1: 0.55, x2: 0.10, y2: -0.28 },
      { x1: -0.55, y1: -0.62, x2: 0.02, y2: -0.62, w: 24 },
    ],
    pads: [{ x: 0.66, y: 0.76, frac: true }],
  },
  palette: { bg: '#f6f1e6', field: '#e3ead4', deep: '#d8e2c6', water: '#c2dbe0' },
  decor: ['boats', 'lighthouse'],
  water: [{ x: 0.80, y: 0 }, { x: 0.62, y: 0.35 }, { x: 0.70, y: 0.62 }, { x: 0.76, y: 0.82 }, { x: 0.68, y: 1 }, { x: 1, y: 1 }, { x: 1, y: 0 }],
  // a3 minor pentatonic: the saudade lean, nylon
  music: { root: 57, mode: 'minor pentatonic', bpm: 60, wind: 0.7, verb: 0.55, bright: 2400 },
};
